import React, { useEffect, useState, Fragment, useRef } from 'react';

// import { XMarkIcon } from '@heroicons/react/20/solid';
import { useMedia } from 'react-use';
import { Dialog as HeadlessDialog, Menu, Transition } from '@headlessui/react';
import CustomDialog from '../shared/Dialog';
import { showStaticToast, showToast } from '../shared/Toast';
import sb_empty from '../../../assets/images/sb_empty.svg';
import defaultProjectPlaceHolder from '../../../assets/images/project_placeholder@2x.jpg';
import {
  CheckIcon,
  Star,
  FunnelXIcon,
  RefreshCcwIcon,
  SearchIcon,
  PlusIcon,
  InfoIcon,
  SlidersHorizontalIcon,
  XIcon,
  ListFilterIcon,
  LockOpen,
  SquareArrowUpRight,
  ArrowUpRight
} from 'lucide-react';

// import Button from '../shared/Button';
import {
  fromRole,
  getDateString,
  getSbStatusColorString,
  getSbStatusStringWithCounts,
  getStorageNotification,
  isExpired,
  OptionProps,
  ProfileStatusMaster,
  ProjectModel,
  saveStorageNotification,
  SbCurrentUser,
  SbStatusMaster,
  SbStatusMasterKeyValueSelect,
  SubmissionBoardFilter,
  SubmissionBoardModel,
} from './component/SbModel';
import SbAdd from './creator/SbAdd';
import SbDetailsListItem from './creator/SbDetailsListItem';
import submissionBoardService from '../services/SubmissionBoardService';
import SelectCombobox from './component/SelectCombobox';
import Breadcrumb from '../shared/Breadcrumb';
import Button from './component/Button';
import SelectList from './component/SelectList';
export interface SubmissionBoardsProps {
  currentUser: SbCurrentUser;
  project: ProjectModel;
  params: any;
  fromPage: string;
}
export default function SubmissionBoardsCreator({
  currentUser,
  project,
  params,
  fromPage,
}: SubmissionBoardsProps) {
  const [records, setRecords] = useState<SubmissionBoardModel[]>([]);
  const [mySbCount, setMySbCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [sortMode, setSortMode] = useState<string>('newest');
  
  const [page, setPage] = useState<number>(1);
  const observerRef = useRef(null);
  // const listRef = useRef(null);
  const [noMoreData, setNoMoreData] = useState<string>('');
  const perPage: number = 10; // Number of records to fetch per page

  const [submissionBoardFilter, setSubmissionBoardFilter] = useState<SubmissionBoardFilter>({
    keyword: '',
    sb_status: 'All',
  });
  const [sbStatusFilter, setSbStatusFilter] = useState<OptionProps>({
    id: 'All',
    name: 'All',
  });
  const [isAddSubmissionBoard, setIsAddSubmissionBoard] = useState<boolean>(false);
  const [editSubmissionBoard, setEditSubmissionBoard] = useState<SubmissionBoardModel | null>(null);
  const [selectedSubmissionBoard, setSelectedSubmissionBoard] =
    useState<SubmissionBoardModel | null>(null);
  const [isSbClosed, setIsSbClosed] = useState(false);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

 
  const [showGuideCard, setShowGuideCard] = useState(
    getStorageNotification('sb_creator') == 1 ? true : false
  );

  const [menuOpenUpward, setMenuOpenUpward] = useState(false);
  const menuButtonRef = useRef<HTMLButtonElement>(null);

  const togglePanel = (index: number) => {
    // If the clicked panel is already open, close it. Otherwise, open the new one.
    setOpenIndex(openIndex === index ? null : index);
  };
  const [isLegendVisible, setIsLegendVisible] = useState(false);

  useEffect(() => {
    if (noMoreData === 'All Submission Boards Loaded') {
      setIsLegendVisible(true);
      const timer = setTimeout(() => {
        setIsLegendVisible(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [noMoreData]);

  // Function to update counts directly without API calls
  const updateSubmissionBoardCounts = (
    sbId: number,
    profileStatusChange: {
      type: 'add' | 'remove' | 'status_change';
      oldStatus?: number;
      newStatus?: number;
    }
  ) => {
    setRecords((prevRecords) => {
      const index = prevRecords.findIndex((sd) => sd.id === sbId);
      if (index !== -1) {
        const _newRecords = [...prevRecords];
        const currentRecord = _newRecords[index];
        let newCounts = { ...currentRecord } as any;
        if (profileStatusChange.type === 'add') {
          // Profile added to submission board
          newCounts.total_profiles = ((newCounts as any).total_profiles || 0) + 1;
          newCounts.total_profiles_pending = ((newCounts as any).total_profiles_pending || 0) + 1;
        } else if (profileStatusChange.type === 'remove') {
          // Profile removed from submission board
          newCounts.total_profiles = Math.max(((newCounts as any).total_profiles || 0) - 1, 0);
          // Decrease the appropriate status count
          if (profileStatusChange.oldStatus === 0) {
            newCounts.total_profiles_pending = Math.max(
              ((newCounts as any).total_profiles_pending || 0) - 1,
              0
            );
          } else if (profileStatusChange.oldStatus === 4) {
            newCounts.total_profiles_onboard = Math.max(
              ((newCounts as any).total_profiles_onboard || 0) - 1,
              0
            );
          } else if (profileStatusChange.oldStatus === 2) {
            newCounts.total_profiles_rejected = Math.max(
              ((newCounts as any).total_profiles_rejected || 0) - 1,
              0
            );
          }
        } else if (profileStatusChange.type === 'status_change') {
          // Profile status changed
          const { oldStatus, newStatus } = profileStatusChange;
          // Decrease old status count
          if (oldStatus === 0) {
            newCounts.total_profiles_pending = Math.max(
              ((newCounts as any).total_profiles_pending || 0) - 1,
              0
            );
          } else if (oldStatus === 4) {
            newCounts.total_profiles_onboard = Math.max(
              ((newCounts as any).total_profiles_onboard || 0) - 1,
              0
            );
          } else if (oldStatus === 2) {
            newCounts.total_profiles_rejected = Math.max(
              ((newCounts as any).total_profiles_rejected || 0) - 1,
              0
            );
          }
          // Increase new status count
          if (newStatus === 0) {
            newCounts.total_profiles_pending = ((newCounts as any).total_profiles_pending || 0) + 1;
          } else if (newStatus === 4) {
            newCounts.total_profiles_onboard =
              ((newCounts as any).total_profiles_onboard || 0) + 1;
          } else if (newStatus === 2) {
            newCounts.total_profiles_rejected =
              ((newCounts as any).total_profiles_rejected || 0) + 1;
          }
        }
        _newRecords[index] = newCounts;
        return _newRecords;
      }
      return prevRecords;
    });
  };
  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);
  const is_xs_res = useMedia('(min-width: 1px) and (max-width: 639px)', false);
  const today = new Date();
  today.setDate(today.getDate() + 14);
  // Function to get status string with counts

  const initSubmissionBoardModel: SubmissionBoardModel = {
    id: 0,
    title: '',
    requirements: '',
    sb_status: SbStatusMaster.open,
    project_id: project.id,
    expire_at: getDateString(today, 'yyyy-MM-dd'),
    created_at: '',
    total_profiles: 0,
    total_profiles_pending: 0,
    total_profiles_onboard: 0,
    total_profiles_rejected: 0,
    multiple_hire: 0,
    is_multiple_hire: false,
    created_by: 0,
    project_folder_uuid: '',
    scene_card_uuid: '',
    request: 0
  };

  const loadMore = async (from: string) => {
    if (isLoading) {
      console.log('sb: loadMore isLoading is true from ' + from);
      return;
    }
    console.log('sb: set isLoading to true, isLoading was false from ' + from);
    setIsLoading(true);
  };
  useEffect(() => {
    if (isLoading) {
      console.log('sb::useEffect[isLoading] call fetchSubmissionBoards page: ' + page);
      const load = async () => {
        await fetchSubmissionBoards(page);
      };
      load();
    }
  }, [isLoading]);

  const refreshRecordList = () => {
    setOpenMenu(false);
    setNoMoreData('');
    setPage(1);
    setOpenIndex(null);
    setRecords([]);
    setSelectedSubmissionBoard(null);
    loadMore('refresh');
  }
  // Load first page
  useEffect(() => {
    console.log('sb::useEffect sortMode');
    refreshRecordList();
  }, [sortMode]);

  // Auto-fill screen after render
  // useEffect(() => {
  //   const checkIfMoreNeeded = () => {
  //     const listBottom = listRef.current?.getBoundingClientRect().bottom || 0;
  //     // console.log('sb::winodws listBottom', listBottom, window.innerHeight);
  //     if (listBottom < window.innerHeight) {
  //       console.log('sb::winodw height more: call loadmore');
  //       loadMore('checkIfMoreNeeded');
  //     }
  //   };

  //   checkIfMoreNeeded();
  //   window.addEventListener('resize', checkIfMoreNeeded);

  //   return () => window.removeEventListener('resize', checkIfMoreNeeded);
  // }, [records]);

  // Infinite scroll on reaching bottom
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        console.log('sb::intersect:observerRef loadmore');
        loadMore('[lastelementvisible]');
      }
    }, {
      rootMargin: '0px 0px 10px 0px',
      threshold: 0
    });

    if (observerRef.current) {
      console.log('observerRef start observerRef')
      observer.observe(observerRef.current);
    } else {
      console.log('no observerRef')
    }

    return () => {
      console.log('observerRef disconnect')
      observer.disconnect()
    };
  }, [observerRef.current, records]);


  const fetchSubmissionBoards = async (pageParam: number) => {
    try {
      if (noMoreData.length > 0 && pageParam != 0) {
        console.log('fetchSubmissionBoards no more data is set');
        return;
      }
      console.log('sb: fetchSubmissionBoards In');

      if (records.length <= 0) {
        pageParam = 1;
      }
      let sb_status = '';
      if (submissionBoardFilter && submissionBoardFilter.sb_status != 'All') {
        sb_status = submissionBoardFilter.sb_status;
      }

      const resp = await submissionBoardService.getSubmissionBoards(
        project.uuid,
        pageParam,
        perPage,
        submissionBoardFilter && submissionBoardFilter.keyword
          ? submissionBoardFilter.keyword.trim()
          : '',
        sb_status,
        sortMode,
        ''
      );
      const { submission_boards, my_sb_count } = resp;
      setMySbCount(my_sb_count);
      if (my_sb_count > 0 && getStorageNotification('sb_creator') == 1) {
        setShowGuideCard(true);
      }
      if (submission_boards && submission_boards.length > 0) {
        if (submission_boards.length < perPage) {
          setNoMoreData('No more profiles...');
        } else {
          setNoMoreData('');
        }
        console.log('sb: fetchSubmissionBoards page:', page);
        setPage((prev) => prev + 1);
        if (params && params.sbid && params.sbid > 0) {
          const sbIndex = submission_boards.findIndex((item) => item.id == params.sbid);
          if (sbIndex !== -1) {
            setOpenIndex(sbIndex);
            setSelectedSubmissionBoard(null);
            await fetchSubmissionBoardAllDetails(submission_boards[sbIndex]);
          }
        }
        // Only fetch counts for non-locked submission boards to optimize performance
        // const submissionBoardsWithCounts = await Promise.all(
        //   submission_boards.map(async (sb: any) => {
        //     // Only fetch counts for non-locked status to optimize performance
        //     if (sb.sb_status !== 'locked') {
        //       try {
        //         // Fetch individual submission board details to get counts
        //         const sbDetails = await submissionBoardService.getSubmissionBoard(
        //           project.uuid,
        //           sb.id,
        //           '',
        //           ''
        //         );
        //         // Calculate counts from the detailed data
        //         const total_profiles = sbDetails.profiles?.length || 0;
        //         const total_profiles_onboard =
        //           sbDetails.profiles?.filter(
        //             (profile: any) => profile.sb_profiles?.[0]?.profile_status === ProfileStatusMaster.Onboard // onboard status
        //           ).length || 0;
        //         return {
        //           ...sb,
        //           total_profiles,
        //           total_profiles_onboard,
        //           total_profiles_pending: 0,
        //           total_profiles_rejected: 0,
        //         };
        //       } catch (error) {
        //         console.error(`Error fetching counts for submission board ${sb.id}:`, error);
        //         // Return with zero counts if there's an error
        //         return {
        //           ...sb,
        //           total_profiles: 0,
        //           total_profiles_onboard: 0,
        //           total_profiles_pending: 0,
        //           total_profiles_rejected: 0,
        //         };
        //       }
        //     } else {
        //       // For locked submission boards, return with zero counts
        //       return {
        //         ...sb,
        //         total_profiles: 0,
        //         total_profiles_onboard: 0,
        //         total_profiles_pending: 0,
        //         total_profiles_rejected: 0,
        //       };
        //     }
        //   })
        // );
        // Fetch recipients for non-locked submission boards to show Submit Board button
        const submissionBoardsWithRecipients = await Promise.all(
          submission_boards.map(async (sb: SubmissionBoardModel) => {
            // Only fetch recipients for non-locked boards from SB_CREATOR
            if (
              fromPage === fromRole.SB_CREATOR &&
              sb.sb_status !== SbStatusMaster.locked &&
              !isExpired(sb.expire_at) &&
              (!sb.recipients || sb.recipients.length === 0)
            ) {
              try {
                const recipients = await submissionBoardService.getSbRecipients(
                  project.uuid,
                  sb.id
                );
                return {
                  ...sb,
                  recipients: recipients || [],
                };
              } catch (error) {
                console.error(`Error fetching recipients for submission board ${sb.id}:`, error);
                return {
                  ...sb,
                  recipients: [],
                };
              }
            }
            return sb;
          })
        );
        setRecords((prevRecords) => [...prevRecords, ...submissionBoardsWithRecipients]);
        // Check if we got fewer records than requested, indicating no more data
        if (submission_boards.length < perPage) {
          setNoMoreData('All Submission Boards Loaded');
        } else {
          setNoMoreData(''); // Clear the message, more data might be available
        }
        return;
      }
      if (pageParam === 1) {
        setNoMoreData('No Matching Submission Boards');
      } else {
        setNoMoreData('All Submission Boards Loaded');
      }
    } catch (error) {
      showToast('Error while fetching submission boards.', 'danger');
    } finally {
      console.log('sb: fetchSubmissionBoards Out');
      console.log('sb: isLoading false');
      setIsLoading(false);
    }
  };
  const fetchSubmissionBoardAllDetails = async (sb_id: number) => {
    let toastId = '';
    try {
      // toastId = showStaticToast('Submitting submission board for review', 'success', 'top-center');
      console.log('sb: fetchSubmissionBoards In');
      const submission_board_resp = await submissionBoardService.getSubmissionBoard(
        project.uuid,
        sb_id,
        '',
        ''
      );
      if (submission_board_resp) {
        if (isExpired(submission_board_resp?.expire_at)) {
          submission_board_resp.sb_status == SbStatusMaster.expired;
        }
        if (
          submission_board_resp.sb_status == SbStatusMaster.expired ||
          submission_board_resp.sb_status == SbStatusMaster.locked
        ) {
          setIsSbClosed(true);
        } else {
          setIsSbClosed(false);
        }
        setSelectedSubmissionBoard(submission_board_resp);
        // Calculate counts from the submission board data
        const total_profiles = submission_board_resp.profiles?.length || 0;
        const total_profiles_onboard =
          submission_board_resp.profiles?.filter(
            (profile: any) => profile.sb_profiles?.[0]?.profile_status === ProfileStatusMaster.Onboard // onboard status
          ).length || 0;
        const total_profiles_pending =
          submission_board_resp.profiles?.filter(
            (profile: any) => profile.sb_profiles?.[0]?.profile_status === ProfileStatusMaster.Pending // pending status
          ).length || 0;
        const total_profiles_rejected =
          submission_board_resp.profiles?.filter(
            (profile: any) => profile.sb_profiles?.[0]?.profile_status === ProfileStatusMaster.Rejected // rejected status
          ).length || 0;
        setRecords((prevRecords) => {
          const index = prevRecords.findIndex((sd) => sd.id === submission_board_resp.id);
          if (index !== -1) {
            const _newRecords = [...prevRecords];
            _newRecords[index] = {
              ...prevRecords[index],
              ...submission_board_resp,
              total_profiles,
              total_profiles_onboard,
              total_profiles_pending,
              total_profiles_rejected,
            };
            return _newRecords;
          } else {
            return prevRecords;
          }
        });
      }
    } catch (error) {
      console.log('error', error);
      showToast('Error while fetching submission boards.', 'danger');
    } finally {
      console.log('sb: fetchSubmissionBoards Out');
      console.log('sb: isLoading false');
      setIsLoading(false);
    }
  };

  const handleSearchClicked = () => { };

  const refreshClicked = async (event?: React.MouseEvent | React.KeyboardEvent) => {
    refreshRecordList();
  };

  const addSubmissionBoardClicked = async (event: React.MouseEvent) => {
    if (fromPage == fromRole.SB_CREATOR) {
      console.log('addSubmissionBoardClicked');
      setIsAddSubmissionBoard(true);
    }
  };

  const submitForReviewClickHandler = async (sbId: number) => {
    let toastId = '';
    try {
      // Optimistically update the status immediately
      setRecords((prevRecords) => {
        const index = prevRecords.findIndex((sb) => sb.id === sbId);
        if (index !== -1) {
          const updatedRecords = [...prevRecords];
          updatedRecords[index] = {
            ...updatedRecords[index],
            sb_status: SbStatusMaster.pending_review,
          };
          return updatedRecords;
        }
        return prevRecords;
      });

      await submissionBoardService.sendSbForReviewToRecipients(project.uuid, sbId);
      showToast('Submitted submission board for review.', 'success');
      // Refresh the submission board to update status with latest data
      const sbIndex = records.findIndex((sb) => sb.id === sbId);
      if (sbIndex !== -1) {
        await fetchSubmissionBoardAllDetails(sbId);
      }
    } catch (error) {
      // Revert the optimistic update on error
      setRecords((prevRecords) => {
        const index = prevRecords.findIndex((sb) => sb.id === sbId);
        if (index !== -1) {
          const updatedRecords = [...prevRecords];
          updatedRecords[index] = {
            ...updatedRecords[index],
            sb_status: SbStatusMaster.open,
          };
          return updatedRecords;
        }
        return prevRecords;
      });
      showToast('Error while sending submission board.', 'danger');
    } finally {

    }
  };
  // const editRecordItemClicked = async (recordItem: any) => {
  //   if(fromPage == fromRole.SB_CREATOR)
  //     {
  //     setEditSubmissionBoard(recordItem);
  //     }
  // };

  const clearFilterClicked = () => {
    setSbStatusFilter({
      id: 'All',
      name: 'All',
    });
    setSubmissionBoardFilter({ keyword: '', sb_status: 'All' });
    setRecords([]);
    setNoMoreData('');
    setPage(1);
    setOpenIndex(null);
    setSelectedSubmissionBoard(null);
    // Automatically reload  with cleared filters
    loadMore('clearFilter');
  };
  
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  const checkMenuPosition = () => {
    if (menuButtonRef.current) {
      const rect = menuButtonRef.current.getBoundingClientRect();
      const menuHeight = 300; // Approximate height of the menu
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      
      // If not enough space below but enough space above, open upward
      setMenuOpenUpward(spaceBelow < menuHeight && spaceAbove > menuHeight);
    }
  };

  // Skeleton loader component for submission boards
  const SubmissionBoardSkeleton = () => (
    <div className="border rounded-md border-gray-200 bg-white">
      <div className="gap-4 flex flex-col sm:flex-row rounded-md justify-between items-center w-full p-4 sm:py-3 sm:px-6 bg-white shadow-sm">
        <div className="flex flex-row items-center justify-between w-full">
          <div className="flex items-center gap-2 flex-1">
            <div className="rounded-lg w-9 h-9 bg-gray-300 animate-pulse"></div>
            <div className="h-5 bg-gray-300 rounded animate-pulse w-48 sm:w-64"></div>
          </div>
          <div className="flex items-center gap-2">
            <div className="hidden sm:flex h-7 w-24 bg-gray-300 rounded-full animate-pulse"></div>
            
            <div className="w-4 h-4 bg-gray-300 rounded animate-pulse"></div>
          </div>
        </div>
        {/* Mobile status skeleton */}
        <div className="flex sm:hidden px-5 py-4 flex-row justify-center border border-gray-200 items-center w-full rounded-lg bg-gray-50">
          <div className="h-7 w-28 bg-gray-300 rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>
  );

  const showGuideUi = () => {
    return (
      <>
        <div className="w-full p-5 bg-blue-100 text-blue-800 font-semibold rounded-lg relative gap-4 flex flex-col">
          {/* Close Button */}
          <div
            id="sb_notification_help_id"
            className="absolute  top-2 right-2 cursor-pointer  w-5 h-5  flex items-center justify-center"
            onClick={() => {
              setShowGuideCard(false);
              saveStorageNotification('sb_creator', 0);
            }}
          >
            <XIcon className="h-5 w-5" aria-hidden="true" />
          </div>

          {/* Main Title */}
          <div className="text-base font-semibold"></div>
          <div className="flex flex-col pl-1 text-base font-normal">
            <div className="flex items-top gap-3 ">
              <div className="h-6 w-5 px-1 flex items-center justify-center">
                <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                  •
                </div>
              </div>
              <div className="m-0" style={{ margin: 0 }}>
                <span className="font-medium">Create Board and Add Selectors:</span> Directors, producers, or assistants.
              </div>
            </div>
            <div className="flex items-top gap-3 ">
              <div className="h-6 w-5 px-1 flex items-center justify-center">
                <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                  •
                </div>
              </div>
              <div className="m-0" style={{ margin: 0 }}>
                <span className="font-medium">Add Performers</span>
              </div>
            </div>
            <div className="flex items-top gap-3 ">
              <div className="h-6 w-5 px-1 flex items-center justify-center">
                <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                  •
                </div>
              </div>
              <div className="m-0" style={{ margin: 0 }}>
                <span className="font-medium">Submit Board:</span> In Edit Board, click the blue Submit Board button to send the board to selectors.
              </div>
            </div>
            <div className="flex items-top gap-3 ">
              <div className="h-6 w-5 px-1 flex items-center justify-center">
                <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                  <Star className="h-4 w-4"></Star>
                </div>
              </div>
              <div className="m-0" style={{ margin: 0 }}>
                <span className="font-medium">Stars & Notes:</span> Optional tools to guide discussion.
              </div>
            </div>
            <div className="flex items-top gap-3 ">
              <div className="h-6 w-5 px-1 flex items-center justify-center">
                <div className="text-blue-900 h-4 w-full flex items-center justify-center">
                  <CheckIcon className="h-4 w-4"></CheckIcon>
                </div>
              </div>
              <div className="m-0" style={{ margin: 0 }}>
                <span className="font-medium">Final Selection:</span> At least one performer must be selected unless multiple selections are enabled. Selectors usually confirm the final choice; coordinators may finalize if needed.
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  const getMenuItemsSorter = () => {
    const menuItems: OptionProps[] =
      [
        { name: 'Newest First', id: 'newest' },
        { name: 'Oldest First', id: 'oldest' },
        { name: 'Expiring First', id: 'expiring_first' },
        { name: 'Expiring Last', id: 'expiring_last' },
        { name: 'Name (A-Z)', id: 'name_az' },
      ];
    return (
      <Menu as="div" className="relative inline-block text-left px-2 py-4 gap-2.5">
        <Menu.Button
          ref={menuButtonRef}
          id="layout_sort_id"
          className={`flex items-center justify-center rounded-md px-4 py-2 gap-x-2.5 flex-row border border-gray-300 bg-white box-shadow-100 text-sm font-semibold text-gray-600 hover:text-black`}
          onClick={checkMenuPosition}
        >
          <div className="w-6 h-6 p-3px flex items-center justify-center">
            <ListFilterIcon className="w-4-2 h-4-2" aria-hidden="true" />
          </div>
        </Menu.Button>

        <Menu.Items className={`absolute right-2 w-48 focus:outline-none z-10 ${menuOpenUpward ? 'bottom-12 origin-bottom-right' : 'mt-2 origin-top-right'}`}>
          <div
            className="absolute right-0 text-gray-300 text-center items-center flex w-4 h-4"
            style={{
              zIndex: 51,
              [menuOpenUpward ? 'bottom' : 'top']: '-10px',
              right: '30px',
              width: '1rem',
            }}
          >
            <div
              className={`absolute right-1/2 -translate-x-1/2 w-4 h-4 border-gray-300 transform bg-white ${menuOpenUpward
                ? 'border-b-2 border-r-2 rotate-45'
                : 'border-t-2 border-l-2 rotate-45'
                }`}
              style={{
                zIndex: 51,
                [menuOpenUpward ? 'bottom' : 'top']: '2px',
                left: '1.5rem',
              }}
            />
          </div>

          <div className="rounded-md py-1 px-1 gap-1 border-gray-300 border bg-white box-shadow-100 ring-1 ring-black ring-opacity-5 flex flex-col">
            {menuItems.map((item: OptionProps, index: number) => {
              return (
                <>
                  <Menu.Item key={index}>
                    {({ active }) => (
                      <div
                        className="cursor-pointer px-2 py-1 gap-2-1 hover:bg-gray-100"
                        onClick={(event: React.MouseEvent) => {
                          // event.preventDefault();
                          let newMode = '';
                          if (typeof item.id === 'number') {
                            newMode = item.id.toString();
                          } else {
                            newMode = item.id;
                          }
                          console.log('newMode', newMode, 'sortMode', sortMode);
                          if (sortMode != newMode) {
                            setSortMode(newMode);
                          }
                        }}
                      >
                        <div className="flex flex-row items-center font-medium text-md p-0 gap-2">
                          {item.name}
                        </div>
                      </div>
                    )}
                  </Menu.Item>
                </>
              );
            })}
          </div>
        </Menu.Items>
      </Menu>
    );
  };

  return (
    <div className="w-full flex flex-col flex-1 mx-auto bg-gray-50">
      <Breadcrumb
        pages={[
          { name: project.title, href: '/projects/' + project.uuid, current: false },
          { name: 'Submission Board', href: '#', current: true },
        ]}
      ></Breadcrumb>

      <div className="w-full flex flex-1 mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-10">
        {/* mobile filters */}

        <Transition.Root show={openMenu} as={Fragment}>
          <HeadlessDialog
            as="div"
            className="relative z-40"
            onClose={() => {
              setOpenMenu(false);
            }}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <HeadlessDialog.Panel className="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-12 shadow-xl">
                  <div className="flex items-center justify-between px-4">
                    <h2 className="text-lg font-medium text-gray-900">Filters</h2>
                    <button
                      type="button"
                      className="-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400"
                      onClick={() => setOpenMenu(false)}
                    >
                      <span className="sr-only">Close menu</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>

                  <div className="mt-4">
                    <div className="flex sm:hidden flex-col gap-4 px-2">
                      <div className="flex items-center gap-2">
                        <label
                          htmlFor="sb_status_id"
                          className="text-sm font-medium text-gray-700 whitespace-nowrap"
                        >
                          Show:
                        </label>
                        <div className="flex items-center w-full" style={{
                        minWidth: '10rem'
                      }}>
                          <SelectList
                            disabled={mySbCount <= 0}
                            id="sb_status_id"
                            options={SbStatusMasterKeyValueSelect}
                            initialValue={sbStatusFilter}
                            onChange={function (value: OptionProps): void {
                              setSbStatusFilter(value);
                              setSubmissionBoardFilter({
                                ...submissionBoardFilter,
                                ['sb_status']: String(value.id),
                              });
                            }}
                          ></SelectList>
                        </div>
                      </div>
                      <div className="flex items-center justify-center">
                        <Button
                          id="search_sb_btn_id"
                          variant="primary"
                          btn_size="small"
                          className="cursor-pointer"
                          onClick={refreshClicked}
                          disabled={mySbCount <= 0}
                        >
                          <div className="w-5 h-5 flex items-center justify-center">
                            <SearchIcon className="w-4 h-4" />
                          </div>
                          <div className="flex">Search</div>
                        </Button>
                      </div>
                      <div className="flex items-center justify-center">
                        <Button
                          id="clear_sb_btn_id"
                          variant="secondary"
                          btn_size="small"
                          className="cursor-pointer"
                          onClick={clearFilterClicked}
                          disabled={mySbCount <= 0}
                        >
                          <div className="w-5 h-5 flex items-center justify-center">
                            <FunnelXIcon className="w-4 h-4" />
                          </div>
                          Clear All Filters
                        </Button>
                      </div>
                    </div>
                  </div>
                </HeadlessDialog.Panel>
              </Transition.Child>
            </div>
          </HeadlessDialog>
        </Transition.Root>
        {/* mobile filters */}

        <div className="w-full max-w-6xl mx-auto">
          <div className="flex w-full items-center justify-between">
            <div className="flex items-start sm:items-center gap-1">
              <span className="text-2xl sm:text-3xl font-medium text-gray-900">
                Submission Boards
              </span>

              {!showGuideCard && (
                <div
                  id="sb_notification_help_id"
                  className="flex items-center justify-center w-4 h-8 rounded-full text-blue-600 hover:text-blue-800 cursor-pointer transition-colors duration-200 ml-1 mt-0.5 sm:mt-0"
                  onClick={() => {
                    setShowGuideCard(true);
                    saveStorageNotification('sb_creator', 1);
                  }}
                >
                  <InfoIcon className="w-4-2 h-4-2 opacity-100" strokeWidth={1.5} />
                </div>
              )}
            </div>
            {fromPage == fromRole.SB_CREATOR && (
              <div className="float-right flex">
                <div
                  id={'create_sb_text_id'}
                  className="lg:inline-flex hidden text-base leading-6 font-medium items-center mr-2 text-blue-500 cursor-pointer"
                  onClick={addSubmissionBoardClicked}
                >
                  Create a Submission Board
                </div>
                <div
                  id={'create_sb_btn_id'}
                  className="inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500  cursor-pointer"
                  onClick={addSubmissionBoardClicked}
                >
                  <PlusIcon className="h-6 w-6" />
                </div>
              </div>
            )}
          </div>
          {/* <hr className="mt-4 mb-4" /> */}
          <div className="flex flex-col relative w-full pt-4">
            {/* top filter bar start */}
            <div className="flex flex-row w-full pb-4 justify-between items-center">
              <div className="flex pr-2 sm:pr-0 flex-row w-full  gap-2  justify-between items-center border-t border-b border-gray-200">
                <div className="flex py-6 flex-row relative items-center gap-2">
                  <div className="flex flex-col gap-1">
                    <input
                      type="text"
                      name="keyword"
                      id="keyword"
                      className="rounded-md border border-gray-300 px-2.5 py-2 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      style={{
                        maxWidth: is_xs_res ? '11.25rem' : 'none'
                      }}
                      placeholder="Search by keyword"
                      disabled={mySbCount <= 0}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setSubmissionBoardFilter({
                          ...submissionBoardFilter,
                          [e.target.name]: e.target.value,
                        });
                      }}
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === 'Enter') {
                          refreshClicked();
                        }
                      }}
                      value={submissionBoardFilter?.keyword || ''}
                    />
                  </div>
                  <div className="hidden sm:flex flex-col gap-1">
                    <div className="flex items-center gap-2">
                      <label
                        htmlFor="sb_status_id"
                        className="text-sm font-medium text-gray-700 whitespace-nowrap"
                      >
                        Show:
                      </label>
                      <div className="flex items-center w-full" style={{
                        minWidth: '10rem'
                      }}>
                        <SelectList
                          disabled={mySbCount <= 0}
                          id="sb_status_id"
                          options={SbStatusMasterKeyValueSelect}
                          initialValue={sbStatusFilter}
                          onChange={function (value: OptionProps): void {
                            setSbStatusFilter(value);
                            setSubmissionBoardFilter({
                              ...submissionBoardFilter,
                              ['sb_status']: String(value.id),
                            });
                          }}
                        ></SelectList>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="flex sm:hidden bg-white border rounded-md py-2.5 px-3.5 gap-3 justify-center text-sm font-medium text-gray-700 hover:text-gray-900"
                    onClick={() => {
                      setOpenMenu(true);
                    }}
                  >
                    <SlidersHorizontalIcon className="w-6 h-6" />
                  </button>
                  <div className="flex">
                    <Button
                      id="search_sb_btn_id"
                      variant="primary"
                      btn_size="small"
                      className="cursor-pointer"
                      onClick={refreshClicked}
                      disabled={mySbCount <= 0}
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        <SearchIcon className="w-4 h-4" />
                      </div>
                      <div className="hidden sm:flex">Search</div>
                    </Button>
                  </div>
                </div>
                {/* <div
                  className="border border-gray-200"
                  style={{
                    width: '1px',
                    height: '-webkit-fill-available',
                    // maxHeight: '2.625rem',
                  }}
                ></div> */}
                <div className="relative flex items-center justify-end gap-2">
                  <div className="relative py-6 hidden sm:flex items-center">
                    <div className="flex items-center gap-2.5 py-2 px-4">
                      <div className="flex">
                        <Button
                          id="clear_sb_btn_id"
                          variant="secondary"
                          btn_size="small"
                          className="cursor-pointer"
                          onClick={clearFilterClicked}
                          disabled={mySbCount <= 0}
                        >
                          <div className="w-5 h-5 flex items-center justify-center">
                            <FunnelXIcon className="w-4 h-4" />
                          </div>
                          Clear All Filters
                        </Button>
                      </div>
                      {mySbCount > 0 && (
                        <Button
                          id="refresh_sb_btn_id"
                          variant="secondary"
                          btn_size="small"
                          className="cursor-pointer"
                          onClick={refreshClicked}
                        >
                          <div className="w-5 h-5 flex items-center justify-center">
                            <RefreshCcwIcon className="w-5 h-5" aria-hidden="true" />
                          </div>
                        </Button>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-center border-l border-gray-200 pl-2">
                    <div className="flex py-6 items-center justify-center">
                      {getMenuItemsSorter()}
                    </div>
                  </div>
                </div>

              </div>
            </div>
            {/* top filter bar end */}
            {/* <hr className="mt-4 mb-4" /> */}

            {/* Guide Card */}
            {showGuideCard && (
              <div className="flex">{showGuideUi()}</div>
            )}

            <div className="flex flex-col w-full">
              {isAddSubmissionBoard && fromPage == fromRole.SB_CREATOR && (
                <>
                  <SbAdd
                    currentUser={currentUser}
                    project={project}
                    submissionBoardModel={initSubmissionBoardModel}
                    dialogCloseHandler={(value: boolean, postData: any) => {
                      if (postData != null) {
                        if (records.length <= 0) {
                          setRecords([postData]);
                          setMySbCount(mySbCount + 1);
                        } else {
                          setRecords((prevRecords) => {
                            const index = prevRecords.findIndex((sb) => sb.id === postData.id);
                            if (index !== -1) {
                              const newUsers = [...prevRecords];
                              let _selectedSubmissionBoard = {
                                ...selectedSubmissionBoard,
                                ...postData,
                                profiles: postData.profiles || [],
                                submission_performers: postData.submission_performers || [],
                                performer_media: postData.performer_media || [],
                              };
                              setSelectedSubmissionBoard(_selectedSubmissionBoard);
                              newUsers[index] = {
                                ...prevRecords[index],
                                ..._selectedSubmissionBoard,
                              };
                              return newUsers;
                            } else {

                              setMySbCount(mySbCount + 1);
                              const newData = [postData, ...prevRecords];
                              console.log('newData SB records', newData);
                              return newData;
                            }
                          });
                        }
                        setTimeout(() => {
                          const indexNew = records.findIndex((sb) => sb.id === postData.id);
                          setOpenIndex(indexNew >= 0? indexNew: 0);
                          setSelectedSubmissionBoard({
                            ...postData,
                            profiles: postData?.profiles || [],
                            submission_performers: postData?.submission_performers || [],
                            performer_media: postData?.performer_media || [],
                          });
                        }, 500);
                      }
                      setIsAddSubmissionBoard(value);
                      
                    }}
                  ></SbAdd>
                </>
              )}
              {editSubmissionBoard != null && fromPage == fromRole.SB_CREATOR && (
                <>
                  <SbAdd
                    currentUser={currentUser}
                    project={project}
                    submissionBoardModel={editSubmissionBoard}
                    dialogCloseHandler={(value: boolean, postData: any) => {
                      if (postData != null) {
                        // Handle deletion case
                        if (postData.deleted && postData.id) {
                          setRecords((prevRecords) =>
                            prevRecords.filter((sb) => sb.id !== postData.id)
                          );
                          setMySbCount((prev) => Math.max(0, prev - 1));
                          setOpenIndex(null);
                          setSelectedSubmissionBoard(null);
                        } else {
                          // Handle update case
                          fetchSubmissionBoardAllDetails(selectedSubmissionBoard.id);
                        }
                      }
                      setEditSubmissionBoard(null);
                      setIsAddSubmissionBoard(value);
                    }}
                  ></SbAdd>
                </>
              )}
              {mySbCount <= 0 && !isLoading && fromPage == fromRole.SB_CREATOR && (
                <div className="flex flex-col w-full h-full items-center justify-center py-10">
                  <div className="w-full">
                    <img
                      className="ml-auto mr-auto w-96 h-full object-cover"
                      src={sb_empty}
                      alt=""
                    />
                  </div>
                  <div className="flex flex-col w-full items-center justify-center gap-4 py-5">
                    <div className="flex font-medium text-lg w-full items-center justify-center">
                      Add Your First Board!
                    </div>
                    <div className="flex  items-center justify-center">
                      <Button
                        id="create_sb_btn_id"
                        className=""
                        variant="primary"
                        btn_size="small"
                        onClick={addSubmissionBoardClicked}
                      >
                        <div className="w-6 h-6  flex items-center justify-center">
                          <PlusIcon className="w-4-2 h-4-2" />
                        </div>
                        Create a Submission Board
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              {(mySbCount > 0 || noMoreData.length > 0) && (
                <div className="mt-1 flex w-full flex-col">
                  <div className="flex w-full flex-col py-2">
                    {/* <%# SB start %> */}
                    <div
                      id="sb_list_id"
                      // ref={listRef}
                      className={
                        (is400_639Screen ? 'px-0' : 'p-0') + ' flex w-full flex-col  gap-6'
                      }
                    >
                      {records.map((item, index) => {
                        const isOpen = openIndex === index;
                        const contentId = `accordion-content-${index}`;
                        const headerId = `accordion-header-${index}`;

                        return (
                          <div
                            key={index}
                            className={`border rounded-md ${isOpen ? 'border-gray-200 ' : 'border-gray-200'
                              }
                            `}
                          >
                            {/* accordian title bar start */}
                            <button
                              id={headerId}
                              type="button"
                              className={`gap-4 flex flex-col sm:flex-row rounded-md justify-between items-center w-full p-4 sm:py-3 sm:px-6 font-semibold text-left transition-colors duration-200
                              ${isOpen ? 'bg-white shadow-sm ' : 'bg-white shadow-sm '}
                              `}
                              onClick={async () => {
                                if (fromPage !== fromRole.SB_EXTERNAL_RECIPIENT) {
                                  if (openIndex === index) {
                                    // closing
                                    togglePanel(index);
                                    setSelectedSubmissionBoard(null);
                                    return;
                                  }
                                  togglePanel(index);
                                  setSelectedSubmissionBoard(null);
                                  await fetchSubmissionBoardAllDetails(item.id);
                                }
                              }}
                              aria-expanded={isOpen}
                              aria-controls={contentId}
                            >
                              <div className="flex flex-row items-center justify-between w-full">
                                <div className="flex items-center gap-2">
                                  <img
                                    className="rounded-lg w-9 h-9 object-cover"
                                    src={project.project_image_thumb || defaultProjectPlaceHolder}
                                    onError={(e) => { (e.target as HTMLImageElement).src = defaultProjectPlaceHolder; }}
                                  ></img>
                                  {(item.header ? item.header + ' / ' : '') + item.title}
                                </div>

                                <div className="flex items-center gap-2">

                                  {!isExpired(item.expire_at) &&
                                    item.sb_status == SbStatusMaster.open &&
                                    fromPage == fromRole.SB_CREATOR &&
                                    ((isOpen && (selectedSubmissionBoard?.recipients?.length > 0 || item.recipients?.length > 0)) ||
                                      (!isOpen && item.recipients && item.recipients.length > 0)) ? (
                                    <div className='flex flex-row h-7 border border-gray-400 rounded-full overflow-hidden'
                                      style={{ lineHeight: '100%', height: '1.65rem' }}
                                    >
                                      <div
                                        className={
                                          'hidden sm:flex font-medium text-sm  items-center chip ' +
                                          getSbStatusColorString(
                                            isExpired(item.expire_at) ? 'expired' : item.sb_status
                                          )
                                        }
                                      >
                                        {getSbStatusStringWithCounts(item)}
                                      </div>
                                      <div className="hidden sm:flex items-center gap-1.5 bg-white px-3"
                                        onClick={async (e) => {
                                          e.stopPropagation();
                                          await submitForReviewClickHandler(item.id);
                                        }}>
                                        <div className="flex flex-col items-start leading-tight">
                                          <span className="text-xs lg:text-sm text-gray-700">Submit Board</span>
                                        </div>
                                        <ArrowUpRight className="w-3.5 h-3.5 text-blue-600 flex-shrink-0" />
                                      </div>
                                    </div>
                                  ) : (<div
                                    style={{ lineHeight: '100%', height: '1.65rem' }}
                                    className={
                                      'hidden sm:flex font-medium text-sm h-7 items-center chip ' +
                                      getSbStatusColorString(
                                        isExpired(item.expire_at) ? 'expired' : item.sb_status
                                      )
                                    }
                                  >
                                    {getSbStatusStringWithCounts(item)}
                                  </div>)}
                                  <svg
                                    className={`
                                    w-4 h-4 transform transition-transform duration-200
                                    ${isOpen ? 'rotate-180' : 'rotate-0'}
                                  `}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M19 9l-7 7-7-7"
                                    ></path>
                                  </svg>
                                </div>
                              </div>
                              {/* mobile start */}
                              <div className="flex sm:hidden px-3 py-4 flex-row justify-center border border-gray-200 items-center w-full rounded-lg bg-gray-50 gap-2">
                                {!isExpired(item.expire_at) &&
                                  item.sb_status == SbStatusMaster.open &&
                                  fromPage == fromRole.SB_CREATOR &&
                                  ((isOpen && (selectedSubmissionBoard?.recipients?.length > 0 || item.recipients?.length > 0)) ||
                                    (!isOpen && item.recipients && item.recipients.length > 0)) ? (
                                  <div className='flex flex-row  border border-gray-400 rounded-full overflow-hidden'
                                    style={{ lineHeight: '100%' }}
                                  >
                                    <div
                                      className={
                                        'flex sm:hidden font-medium text-sm  items-center chip ' +
                                        getSbStatusColorString(
                                          isExpired(item.expire_at) ? 'expired' : item.sb_status
                                        )
                                      }
                                    >
                                      {getSbStatusStringWithCounts(item)}
                                    </div>
                                    <div className="flex items-center gap-1.5 bg-white px-3"
                                      onClick={async (e) => {
                                        e.stopPropagation();
                                        await submitForReviewClickHandler(item.id);
                                      }}>
                                      <div className="flex flex-col items-start leading-tight">
                                        <span className="text-xs lg:text-sm text-gray-700">Submit Board</span>
                                      </div>
                                      <ArrowUpRight className="w-3.5 h-3.5 text-blue-600 flex-shrink-0" />
                                    </div>
                                  </div>
                                ) : (<div
                                  style={{ lineHeight: '100%' }}
                                  className={
                                    'flex sm:hidden font-medium text-sm items-center chip ' +
                                    getSbStatusColorString(
                                      isExpired(item.expire_at) ? 'expired' : item.sb_status
                                    )
                                  }
                                >
                                  {getSbStatusStringWithCounts(item)}
                                </div>)}
                              </div>
                              {/* mobile end */}
                            </button>
                            {/* accordian title bar end */}
                            {/* accordian title body start */}
                            {/* {index == 0 && <div
                                className={`
                              transition-all duration-300 ease-in-out
                              max-h opacity-100 pb-4 bg-white`}><PreferredByRecipentDummy /></div>} */}
                            {openIndex != null && openIndex === index && (
                              <div
                                id={contentId}
                                role="region"
                                aria-labelledby={headerId}
                                className={`
                              transition-all duration-300 ease-in-out rounded-md	
                              ${isOpen ? 'max-h opacity-100 pb-4 bg-white' : 'max-h-0 opacity-0'}
                            `}
                              >
                                {selectedSubmissionBoard != null && (
                                  <div>
                                    <SbDetailsListItem
                                      fromScreen={fromPage}
                                      indexRow={index}
                                      currentUser={currentUser}
                                      project={project}
                                      submissionBoardModel={selectedSubmissionBoard}
                                      dialogCloseHandler={() => {
                                        setSelectedSubmissionBoard(null);
                                      }}
                                      refreshSubmissionBoard={() => {
                                        fetchSubmissionBoardAllDetails(selectedSubmissionBoard.id);
                                      }}
                                      updateSubmissionBoardCounts={updateSubmissionBoardCounts}
                                      editSb={function (index: number): void {
                                        if (fromPage == fromRole.SB_CREATOR) {
                                          setEditSubmissionBoard(item);
                                        }
                                      }}
                                    ></SbDetailsListItem>
                                  </div>
                                )}
                              </div>
                            )}
                            {/* accordian title body end */}
                          </div>
                        );
                      })}
                      {isLoading && (
                        <div className="flex flex-col w-full gap-6">
                          {[...Array(records.length > 0 ? 1 : 3)].map((_, i) => (
                            <SubmissionBoardSkeleton key={`skeleton-${i}`} />
                          ))}
                        </div>
                      )}
                    </div>
                    {/* <%# SB end %> */}
                  </div>
                  <div className="w-full py-2 flex flex-col justify-center">
                    {noMoreData.length > 0 && records.length === 0 && !isLoading && (
                      <div className="justify-center items-center flex w-full ">
                        <div className="text-center text-gray-500 text-lg">{noMoreData}</div>
                      </div>
                    )}
                    {noMoreData.length > 0 && records.length > 0 && (
                      <div
                        className={`flex flex-row w-full font-bold text-xl justify-center transition-opacity duration-1000 ease-out ${isLegendVisible ? 'opacity-100' : 'opacity-0'
                          }`}
                        style={{ paddingTop: '0.625rem' }}
                      >
                        All Submission Boards Loaded
                      </div>
                    )}
                  </div>
                  <div className="w-full py-2 flex flex-col justify-center">
                    <div className="flex w-full justify-center" ref={observerRef}>
                      {noMoreData.length <= 0 && records.length > 0 && !isLoading && (
                        <Button
                          id="load_more_sb_btn_id"
                          variant="secondary"
                          btn_size="small"
                          className="absolute  cursor-pointer"
                          onClick={() => {
                            loadMore('loadMoreButton');
                          }}
                        >
                          <div className="w-6 h-6  flex items-center justify-center">
                            <RefreshCcwIcon className="h-6 w-6" aria-hidden="true" />
                          </div>
                          Load More Submissions
                        </Button>
                      )}
                    </div>
                  </div>

                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
